<template>
    <div :style="getStyles"
         class="text-main-2xl main-text-color flex items-center font-medium truncate">
        {{ getDateInterval }}
    </div>
</template>
<script>
import { timeFilterToHuman, timeFilterForPeriod, timeFilterForCalendricalPeriod } from '@/helpers/widgetUtils'

export default {
    props: {
        widget: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        getStyles() {
            return this.$store.getters['layout/widgetTitleStyles']('activeLayout')
        },
        getDateInterval() {
            if (this.widget.WidgetTime.type === 'period' && this.widget.WidgetTime.is_calendrical) {
                return timeFilterForCalendricalPeriod(this.widget, 'dd.MM.yyyy')
            }
            if (this.widget.WidgetTime.type === 'period') {
                return timeFilterForPeriod(this.widget, 'dd.MM.yyyy')
            }
            return timeFilterToHuman(this.widget, 'dd.MM.yyyy')
        }
    }
}
</script>
